import { NgModule } from '@angular/core';

import { SATELLITE, satelliteFactory } from './satellite';
import { DATA_STORE, dataStoreFactory } from './data-store';
import { adobeDataStoreFactory, ADOBE_DATA_STORE } from './adobe-data-store';

@NgModule({
  providers: [
    { provide: SATELLITE, useFactory: satelliteFactory },
    {
      provide: DATA_STORE,
      useFactory: dataStoreFactory,
    },
    {
      provide: ADOBE_DATA_STORE,
      useFactory: adobeDataStoreFactory,
    },
  ],
})
export class AnalyticsDataAccessModule {}
